import { render, staticRenderFns } from "./CheckoutManual.vue?vue&type=template&id=393af836"
import script from "./CheckoutManual.vue?vue&type=script&lang=js"
export * from "./CheckoutManual.vue?vue&type=script&lang=js"
import style0 from "./CheckoutManual.vue?vue&type=style&index=0&id=393af836&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports